import { useState } from "react";

const useLocalStorage = (key: string, defaultValue?: any) => {
  // Create state variable to store
  // localStorage value in state
  // const [localStorageValue, setLocalStorageValue] = useState(() => {
  //   try {
  //     const value = localStorage.getItem(key);
  //     // If value is already present in
  //     // localStorage then return it

  //     // Else set default value in
  //     // localStorage (if provided) and then return it
  //     if (value) {
  //       return JSON.parse(value);
  //     } else if (defaultValue !== undefined) {
  //       localStorage.setItem(key, JSON.stringify(defaultValue));
  //       return defaultValue;
  //     }
  //     return null; // Return null if no default value provided
  //   } catch (error) {
  //     if (defaultValue !== undefined) {
  //       localStorage.setItem(key, JSON.stringify(defaultValue));
  //       return defaultValue;
  //     }
  //     return null; // Return null in case of error and no default value
  //   }
  // });

  // // this method updates our localStorage and our state
  // const setLocalStorageStateValue = (valueOrFn: any) => {
  //   let newValue;
  //   if (typeof valueOrFn === "function") {
  //     const fn = valueOrFn;
  //     newValue = fn(localStorageValue);
  //   } else {
  //     newValue = valueOrFn;
  //   }
  //   localStorage.setItem(key, JSON.stringify(newValue));
  //   setLocalStorageValue(newValue);
  // };

  return [localStorage.getItem(key), (key: any) => {}] as const;
};

export default useLocalStorage;
